var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { IntlProvider } from 'react-intl';
import i18n from '../../../../i18n';
const defaultLocale = 'en'; // TODO: need to work on that too
const Localization = (_a) => {
    var { locale } = _a, props = __rest(_a, ["locale"]);
    const messages = locale in i18n ? i18n[locale] : i18n[defaultLocale];
    return (React.createElement(IntlProvider, Object.assign({ defaultLocale: defaultLocale, locale: locale, messages: messages }, props)));
};
export default Localization;
//# sourceMappingURL=index.js.map